// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_tRn","left":"styles_left__7CUh7"};